import { setCookie, getCookie } from "./cookie";

const $notifyBar = $(".notification-bar");

if (!getCookie("notifyBar")) {
  $notifyBar.fadeIn();
}

$notifyBar.find(".close").on("click", function() {
  $(this).parent().fadeOut();
  setCookie("notifyBar", "true", 999);
});



// WEBPACK FOOTER //
// ../assets/js/notification-bar.js